import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  Output,
} from '@angular/core';
import { ButtonSize, NativeButtonType } from '@app/components/button';

export enum ActionType {
  ADD = 'add',
  DELETE = 'delete',
  SAVE = 'save',
  EDIT = 'edit',
  UPLOAD = 'upload',
  RESET_TO_DEFAULT = 'resetToDefault',
}

@Component({
  standalone: true,
  selector: 'app-form-action-button',
  templateUrl: './form-action-button.component.html',
  styleUrls: ['./form-action-button.component.css'],
  imports: [CommonModule],
})
export class FormActionButtonComponent {
  type = input.required<ActionType>();
  label = input<string>();
  @Input() buttonType: NativeButtonType = NativeButtonType.BUTTON;
  @Input() disabled = false;
  @Input() testId!: string;
  @Input() icon = true;
  @Input() iconSize = 16;
  @Input() iconXOffset = 0;
  @Input() iconYOffset = 0;
  @Input() size: ButtonSize = ButtonSize.LARGE;
  @Output() handleClick = new EventEmitter<void>();
  actionType = ActionType;
  nativeButtonType = NativeButtonType;
  buttonSize = ButtonSize;

  buttonText = computed(() => {
    const label = this.label();
    if (label !== undefined && label !== null) return label;
    return this.type() === this.actionType.RESET_TO_DEFAULT
      ? 'RESET TO DEFAULT'
      : this.type();
  });

  get iconViewBox(): string {
    return `${this.iconXOffset} ${this.iconYOffset} ${this.iconSize} ${this.iconSize}`;
  }

  onClick() {
    this.handleClick.emit();
  }
}
